import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const ax  = axios.create({ baseURL: API, withCredentials: true });

const RED    = '#E5341A';
const TEXT   = '#F0F0F0';
const MUTED  = '#555';
const BG     = '#0d0d0d';
const SURF   = '#111';

function fmt(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('fr-CA', { year: 'numeric', month: 'short', day: 'numeric' });
}

function ConfirmDeleteModal({ user, onConfirm, onClose }) {
  const [busy, setBusy] = useState(false);
  async function go() { setBusy(true); await onConfirm(); onClose(); }
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 900, background: 'rgba(0,0,0,0.75)' }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 901, background: '#111', borderRadius: 18, padding: 32, width: 400, maxWidth: '90vw', border: '1px solid rgba(248,113,113,0.25)', boxShadow: '0 24px 60px rgba(0,0,0,0.7)' }}>
        <div style={{ fontSize: '1.8rem', marginBottom: 12, textAlign: 'center' }}>🗑</div>
        <div style={{ fontWeight: 800, fontSize: '1rem', color: '#F0F0F0', marginBottom: 8, textAlign: 'center' }}>Supprimer ce compte ?</div>
        <div style={{ fontSize: '0.82rem', color: '#777', marginBottom: 6, textAlign: 'center' }}>{user.name}</div>
        <div style={{ fontSize: '0.82rem', color: '#555', marginBottom: 24, textAlign: 'center' }}>{user.email}</div>
        <div style={{ background: 'rgba(248,113,113,0.07)', border: '1px solid rgba(248,113,113,0.18)', borderRadius: 10, padding: '12px 16px', color: '#f87171', fontSize: '0.78rem', marginBottom: 24, lineHeight: 1.6 }}>
          Cette action est irréversible. Le compte Firebase et le profil QuébecStream seront définitivement effacés.
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: 'none', color: '#F0F0F0', borderRadius: 10, padding: '12px', cursor: 'pointer', fontSize: '0.88rem' }}>Annuler</button>
          <button onClick={go} disabled={busy} style={{ flex: 1, background: busy ? '#333' : '#dc2626', border: 'none', color: '#fff', borderRadius: 10, padding: '12px', cursor: busy ? 'wait' : 'pointer', fontWeight: 700, fontSize: '0.88rem' }}>
            {busy ? '⏳ Suppression…' : 'Supprimer'}
          </button>
        </div>
      </div>
    </>
  );
}

function CreateUserModal({ onClose, onCreated }) {
  const [form,    setForm]    = useState({ email: '', password: '', name: '' });
  const [saving,  setSaving]  = useState(false);
  const [err,     setErr]     = useState('');

  async function save(e) {
    e.preventDefault();
    setErr('');
    setSaving(true);
    try {
      await ax.post('/api/quebecstream/users/create', form);
      onCreated();
      onClose();
    } catch (e) {
      setErr(e.response?.data?.error || 'Erreur');
    }
    setSaving(false);
  }

  const inp = { width: '100%', background: '#0d0d0d', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#F0F0F0', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', marginBottom: 14 };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 800, background: 'rgba(0,0,0,0.7)' }} />
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 801, background: '#111', borderRadius: 18, padding: 32, width: 440, maxWidth: '90vw', border: '1px solid rgba(255,255,255,0.09)', boxShadow: '0 24px 60px rgba(0,0,0,0.6)' }}>
        <div style={{ fontWeight: 800, fontSize: '1.1rem', color: '#F0F0F0', marginBottom: 6 }}>Créer un usager</div>
        <div style={{ fontSize: '0.78rem', color: '#555', marginBottom: 24 }}>Le compte sera créé directement — l'usager se connecte avec ces identifiants.</div>
        <form onSubmit={save}>
          <div style={{ fontSize: '0.7rem', color: '#555', fontWeight: 700, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Prénom / Nom</div>
          <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Marie Tremblay" style={inp} />
          <div style={{ fontSize: '0.7rem', color: '#555', fontWeight: 700, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Courriel</div>
          <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="marie@exemple.com" style={inp} required />
          <div style={{ fontSize: '0.7rem', color: '#555', fontWeight: 700, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Mot de passe temporaire</div>
          <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="6 caractères minimum" style={{ ...inp, marginBottom: 4 }} required minLength={6} />
          <div style={{ fontSize: '0.7rem', color: '#555', marginBottom: 20 }}>Partagez ces identifiants avec l'usager — il pourra les changer après connexion.</div>
          {err && <div style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.2)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: '0.82rem', marginBottom: 16 }}>{err}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={onClose} style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: 'none', color: '#F0F0F0', borderRadius: 10, padding: '12px', cursor: 'pointer', fontSize: '0.88rem' }}>Annuler</button>
            <button type="submit" disabled={saving} style={{ flex: 2, background: saving ? '#333' : RED, border: 'none', color: '#fff', borderRadius: 10, padding: '12px', cursor: saving ? 'wait' : 'pointer', fontWeight: 700, fontSize: '0.88rem' }}>
              {saving ? '⏳ Création…' : '+ Créer le compte'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default function QSUsersSection() {
  const [users,       setUsers]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [query,       setQuery]       = useState('');
  const [acting,      setActing]      = useState(null);
  const [msg,         setMsg]         = useState('');
  const [showCreate,  setShowCreate]  = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  async function load() {
    setLoading(true);
    try {
      const { data } = await ax.get('/api/quebecstream/users');
      setUsers(Array.isArray(data) ? data : []);
    } catch { setUsers([]); }
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  async function toggle(uid, disabled) {
    setActing(uid);
    try {
      await ax.put(`/api/quebecstream/users/${uid}/${disabled ? 'enable' : 'disable'}`);
      setMsg(disabled ? '✅ Compte réactivé' : '🚫 Compte désactivé');
      setUsers(u => u.map(x => x.uid === uid ? { ...x, disabled: !disabled } : x));
    } catch { setMsg('❌ Erreur'); }
    setActing(null);
    setTimeout(() => setMsg(''), 3000);
  }

  async function remove(uid) {
    setActing(uid);
    try {
      await ax.delete(`/api/quebecstream/users/${uid}`);
      setMsg('🗑 Compte supprimé');
      setUsers(u => u.filter(x => x.uid !== uid));
    } catch { setMsg('❌ Erreur'); }
    setActing(null);
    setTimeout(() => setMsg(''), 3000);
  }

  const filtered = users.filter(u =>
    !query || u.email?.toLowerCase().includes(query.toLowerCase()) || u.name?.toLowerCase().includes(query.toLowerCase())
  );

  const total    = users.length;
  const actifs   = users.filter(u => !u.disabled).length;
  const desactiv = users.filter(u =>  u.disabled).length;

  const s = {
    label: { fontSize: '0.65rem', color: RED, fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 6 },
    card:  { background: SURF, borderRadius: 14, border: '1px solid rgba(255,255,255,0.06)', padding: '20px 24px' },
  };

  return (
    <div style={{ padding: '32px 28px', fontFamily: 'Inter, system-ui, sans-serif', color: TEXT, background: BG, minHeight: '100vh' }}>

      {showCreate && <CreateUserModal onClose={() => setShowCreate(false)} onCreated={load} />}
      {deleteTarget && (
        <ConfirmDeleteModal
          user={deleteTarget}
          onConfirm={() => remove(deleteTarget.uid)}
          onClose={() => setDeleteTarget(null)}
        />
      )}

      {/* En-tête */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 28, flexWrap: 'wrap', gap: 16 }}>
        <div>
          <div style={s.label}>📺 QuébecStream</div>
          <h2 style={{ margin: '0 0 6px', fontSize: '1.6rem', fontWeight: 900 }}>Usagers</h2>
          <p style={{ margin: 0, color: MUTED, fontSize: '0.85rem' }}>Accès sur invitation — vous contrôlez tous les comptes.</p>
        </div>
        <button onClick={() => setShowCreate(true)} style={{ background: RED, border: 'none', color: '#fff', borderRadius: 10, padding: '11px 20px', fontSize: '0.88rem', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
          + Créer un usager
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 28 }}>
        {[['Total', total, '#F0F0F0'], ['Actifs', actifs, '#4ade80'], ['Désactivés', desactiv, '#f87171']].map(([label, val, col]) => (
          <div key={label} style={{ ...s.card, textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', fontWeight: 900, color: col }}>{val}</div>
            <div style={{ fontSize: '0.75rem', color: MUTED, marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Barre recherche + message */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <input
          value={query} onChange={e => setQuery(e.target.value)}
          placeholder="Rechercher par nom ou courriel…"
          style={{ flex: 1, background: SURF, border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: '11px 16px', color: TEXT, fontSize: '0.88rem', outline: 'none' }}
        />
        <button onClick={load} style={{ background: SURF, border: '1px solid rgba(255,255,255,0.1)', color: TEXT, borderRadius: 10, padding: '11px 16px', cursor: 'pointer', fontSize: '0.82rem' }}>
          ↻ Rafraîchir
        </button>
      </div>

      {msg && (
        <div style={{ background: msg.startsWith('✅') || msg.startsWith('🗑') ? 'rgba(74,222,128,0.08)' : 'rgba(248,113,113,0.08)', border: `1px solid ${msg.startsWith('❌') ? 'rgba(248,113,113,0.2)' : 'rgba(74,222,128,0.2)'}`, borderRadius: 8, padding: '10px 16px', color: msg.startsWith('❌') ? '#f87171' : '#4ade80', fontSize: '0.83rem', marginBottom: 16 }}>
          {msg}
        </div>
      )}

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px 0', color: MUTED }}>
          <div style={{ width: 36, height: 36, border: `3px solid ${RED}`, borderTopColor: 'transparent', borderRadius: '50%', animation: 'qsSpin 0.8s linear infinite', margin: '0 auto 14px' }} />
          Chargement…
          <style>{`@keyframes qsSpin { to { transform: rotate(360deg); } }`}</style>
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0', color: MUTED }}>
          <div style={{ fontSize: '2rem', marginBottom: 12 }}>👤</div>
          {query ? 'Aucun résultat.' : 'Aucun usager inscrit.'}
        </div>
      ) : (
        <div style={{ ...s.card, padding: 0, overflow: 'hidden' }}>
          {/* Header */}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr', gap: 0, padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,0.06)', background: '#0d0d0d' }}>
            {['Nom', 'Courriel', 'Inscrit', 'Dernière co.', 'Actions'].map(h => (
              <div key={h} style={{ fontSize: '0.65rem', fontWeight: 800, color: MUTED, letterSpacing: '0.1em', textTransform: 'uppercase' }}>{h}</div>
            ))}
          </div>

          {filtered.map((u, i) => (
            <div key={u.uid} style={{
              display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr', gap: 0,
              padding: '14px 20px', alignItems: 'center',
              borderBottom: i < filtered.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
              background: u.disabled ? 'rgba(248,113,113,0.04)' : 'transparent',
              transition: 'background 0.15s',
            }}>
              {/* Nom */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: u.disabled ? '#333' : 'rgba(229,52,26,0.2)', border: `1px solid ${u.disabled ? '#333' : RED + '44'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.72rem', fontWeight: 800, color: u.disabled ? MUTED : RED, flexShrink: 0 }}>
                  {u.name?.[0]?.toUpperCase() || u.email?.[0]?.toUpperCase() || '?'}
                </div>
                <div>
                  <div style={{ fontSize: '0.85rem', fontWeight: 600, color: u.disabled ? MUTED : TEXT }}>{u.name || '—'}</div>
                  {u.disabled && <div style={{ fontSize: '0.62rem', color: '#f87171', fontWeight: 700 }}>DÉSACTIVÉ</div>}
                </div>
              </div>

              {/* Courriel */}
              <div style={{ fontSize: '0.82rem', color: MUTED, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: 12 }}>{u.email}</div>

              {/* Inscrit */}
              <div style={{ fontSize: '0.78rem', color: MUTED }}>{fmt(u.createdAt)}</div>

              {/* Dernière connexion */}
              <div style={{ fontSize: '0.78rem', color: MUTED }}>{fmt(u.lastLogin)}</div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  onClick={() => toggle(u.uid, u.disabled)}
                  disabled={acting === u.uid}
                  title={u.disabled ? 'Réactiver' : 'Désactiver'}
                  style={{ background: u.disabled ? 'rgba(74,222,128,0.12)' : 'rgba(248,113,113,0.1)', border: `1px solid ${u.disabled ? 'rgba(74,222,128,0.2)' : 'rgba(248,113,113,0.2)'}`, color: u.disabled ? '#4ade80' : '#f87171', borderRadius: 6, padding: '5px 10px', fontSize: '0.72rem', cursor: acting === u.uid ? 'wait' : 'pointer', fontWeight: 600 }}>
                  {u.disabled ? '✓ Réactiver' : '✕ Désactiver'}
                </button>
                <button
                  onClick={() => setDeleteTarget(u)}
                  disabled={acting === u.uid}
                  title="Supprimer définitivement"
                  style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: MUTED, borderRadius: 6, padding: '5px 10px', fontSize: '0.72rem', cursor: acting === u.uid ? 'wait' : 'pointer' }}>
                  🗑
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: 20, color: MUTED, fontSize: '0.75rem' }}>
        {filtered.length} usager{filtered.length !== 1 ? 's' : ''} affiché{filtered.length !== 1 ? 's' : ''}
        {query ? ` sur ${total} total` : ''}.
        Les usagers Vybme, Axispme et autres sites sont complètement isolés — ils ne peuvent pas accéder à QuébecStream.
      </div>
    </div>
  );
}
